module.exports = __webpack_public_path__ + "static/media/machine.b5f6ba44.svg";